var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTimer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20934_15162)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.602539 5.99995C0.602539 8.97649 3.02341 11.3974 5.99995 11.3974C8.97649 11.3974 11.3974 8.97649 11.3974 5.99995C11.3974 3.02341 8.97649 0.602539 5.99995 0.602539C5.83054 0.602539 5.66806 0.66984 5.54826 0.789637C5.42846 0.909434 5.36116 1.07191 5.36116 1.24133V2.72101C5.36116 2.89043 5.42846 3.05291 5.54826 3.17271C5.66806 3.29251 5.83054 3.35981 5.99995 3.35981C6.16937 3.35981 6.33185 3.29251 6.45165 3.17271C6.57145 3.05291 6.63875 2.89043 6.63875 2.72101V1.92945C8.6082 2.23719 10.1198 3.94559 10.1198 5.99995C10.1198 8.27155 8.27155 10.1198 5.99995 10.1198C3.72847 10.1198 1.88031 8.27174 1.88013 6.0003C1.88338 4.90805 2.31697 3.86109 3.08691 3.08636C3.1461 3.02711 3.19305 2.95679 3.2251 2.87942C3.2572 2.80192 3.27372 2.71887 3.27372 2.63499C3.27372 2.55111 3.2572 2.46805 3.2251 2.39056C3.193 2.31306 3.14595 2.24265 3.08664 2.18334C3.02733 2.12402 2.95691 2.07698 2.87942 2.04488C2.80192 2.01278 2.71887 1.99626 2.63499 1.99626C2.55111 1.99626 2.46805 2.01278 2.39056 2.04488C2.31306 2.07698 2.24265 2.12402 2.18334 2.18334C1.17824 3.18844 0.602539 4.5785 0.602539 5.99995Z",
    fill: "#09090A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74163 5.25301L6.72944 5.24124L4.709 3.80595C4.59084 3.69529 4.43481 3.63344 4.2724 3.63344C4.103 3.63344 3.94053 3.70073 3.82075 3.82052C3.70096 3.9403 3.63367 4.10277 3.63367 4.27217C3.63367 4.43458 3.69552 4.59061 3.80618 4.70877L5.2415 6.72918L5.25328 6.74137C5.35038 6.84191 5.46653 6.92209 5.59494 6.97725C5.72336 7.03242 5.86148 7.06145 6.00124 7.06267C6.141 7.06388 6.27961 7.03725 6.40897 6.98433C6.53832 6.9314 6.65584 6.85325 6.75468 6.75442C6.85351 6.65558 6.93166 6.53806 6.98459 6.40871C7.03751 6.27935 7.06414 6.14074 7.06293 6.00098C7.06171 5.86122 7.03268 5.7231 6.97751 5.59468C6.92235 5.46626 6.84217 5.35012 6.74163 5.25301Z",
    fill: "#09090A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20934_15162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTimer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-timer.247a51970713aa7eb0b9b8ff485fd2a0.svg";